module.exports = __webpack_public_path__ + "static/media/promo_code.4e95d4de.svg";